import React from 'react';
import ButtonSeplag from '../../../../components/buttonSeplag/ButtonSeplag';
import propostaIndicadorService from '../../../../service/PropostaIndicadorService';
import { download } from '../../../../core/utils/Exporter';
import PageMessages from '../../../../config/translations/PageMessages';
import analiseMetodologicaService from '../../../../service/AnaliseMetodologicaService';
import analiseNegocialService from '../../../../service/AnaliseNegocialService';
import Pages from '../../../../config/Pages';
import { useHistory } from 'react-router-dom';
import Shareds from '../../../../config/translations/Shareds';
import { printToast } from '../../../../core/utils/Global';
import { errosTratados } from '../../../../config/Axios';

function ActionButtons({
    data: { avaliacaoNegocial, avaliacaoMetodologica, ...data },
    modalJustificativaRef,
    mensagemRef,
    confirmRef,
    formRef,
}) {
    const history = useHistory();
    return (
        <>
            <ButtonSeplag
                tipo="danger"
                type="button"
                tooltip="Excluir"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-trash"
                disabled={data?.situacaoProposta?.codgSituacaoProposta !== 'CADASTRO'}
                onClick={() => {
                    if (data?.tipoProposta?.codgTipoProposta === 'ALTERACAO_INDICADOR') {
                        mensagemRef.current?.show(
                            PageMessages.sei.propostaIndicador.tipoPropostaExcluir
                        );
                    } else {
                        confirmRef.current.show(Shareds.form.confirmDelete, async () => {
                            try {
                                await propostaIndicadorService.remover(data);
                                formRef.current.formik.submitForm();
                                printToast({
                                    severity: 'success',
                                    summary: Pages.sei.propostaIndicador.title,
                                    detail: Shareds.form.successDelete,
                                });
                            } catch (error) {
                                if (!errosTratados.includes(error?.response?.status)) {
                                    printToast({
                                        severity: 'error',
                                        summary: Pages.sei.propostaIndicador.title,
                                        detail: Shareds.form.errorDelete,
                                    });
                                }
                            }
                        });
                    }
                }}
                style={{ marginLeft: '.5em' }}
                theme="Raised"
            />
            <ButtonSeplag
                tipo="warning"
                type="button"
                tooltip="Editar"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-pencil"
                disabled={
                    !['CADASTRO', 'REVISAR_PROPOSTA'].includes(
                        data?.situacaoProposta?.codgSituacaoProposta
                    )
                }
                onClick={() => {
                    if (data?.tipoProposta?.codgTipoProposta === 'ALTERACAO_INDICADOR') {
                        mensagemRef.current?.show(
                            PageMessages.sei.propostaIndicador.tipoPropostaAlterar
                        );
                    } else {
                        history.push(Pages.sei.propostaIndicador.url.edit.replace(':id', data?.id));
                    }
                }}
                style={{ marginLeft: '.5em', marginTop: '.2em' }}
            />
            <ButtonSeplag
                tipo="danger"
                type="button"
                tooltip="Cancelar"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-ban"
                disabled={data?.situacaoProposta?.codgSituacaoProposta === 'APROVADA'}
                onClick={() => {
                    if (data?.situacaoProposta?.codgSituacaoProposta === 'CANCELADA') {
                        modalJustificativaRef.current?.show(data);
                    } else if (data?.tipoProposta?.codgTipoProposta === 'ALTERACAO_INDICADOR') {
                        mensagemRef.current?.show(
                            PageMessages.sei.propostaIndicador.tipoPropostaCancelar
                        );
                    } else {
                        confirmRef.current?.show(PageMessages.sei.propostaIndicador.cancelar, () =>
                            setTimeout(() => modalJustificativaRef.current?.show(data), 300)
                        );
                    }
                }}
                style={{ marginTop: '.2em' }}
            />
            <ButtonSeplag
                tipo="help"
                type="button"
                tooltip="Relatório da Proposta"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-file-pdf"
                onClick={() =>
                    propostaIndicadorService
                        .getRelatorioProposta(data.id)
                        .then((response) => download(response, 'Proposta', 'pdf'))
                }
                style={{ marginLeft: '.5em', marginTop: '.2em' }}
                theme="Raised"
            />
            <ButtonSeplag
                tipo="secondary"
                type="button"
                tooltip="Relatório da Análise Negocial"
                tooltipOptions={{ position: 'top' }}
                disabled={!avaliacaoNegocial?.id}
                icon="pi pi-file-pdf"
                onClick={() =>
                    analiseNegocialService
                        .getRelatorio(avaliacaoNegocial?.id)
                        .then((response) => download(response, 'Analise Negocial', 'pdf'))
                }
                style={{ marginLeft: '.5em', marginTop: '.2em' }}
                theme="Raised"
            />
            <ButtonSeplag
                tipo="primary"
                type="button"
                tooltip="Relatório da Análise Meotodológica"
                tooltipOptions={{ position: 'top' }}
                disabled={!avaliacaoMetodologica?.id}
                icon="pi pi-file-pdf"
                onClick={() =>
                    analiseMetodologicaService
                        .getRelatorio(avaliacaoMetodologica?.id)
                        .then((response) => download(response, 'Analise Metodológica', 'pdf'))
                }
                style={{ marginLeft: '.5em', marginTop: '.2em' }}
                theme="Raised"
            />
            <ButtonSeplag
                tipo="warning"
                type="button"
                tooltip="Resumo de Alteração"
                tooltipOptions={{ position: 'top' }}
                disabled={data?.tipoProposta?.codgTipoProposta !== 'ALTERACAO_INDICADOR'}
                icon="pi pi-file-pdf"
                onClick={() =>
                    propostaIndicadorService
                        .getRelatorioResumoProposta(data.id)
                        .then((response) => download(response, 'Resumo', 'pdf'))
                }
                style={{ marginTop: '.2em' }}
                theme="Raised"
            />
        </>
    );
}

export default ActionButtons;
